var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3531 3.50938L7.99063 0.146875C7.89688 0.053125 7.77031 0 7.6375 0H1C0.723438 0 0.5 0.223437 0.5 0.5V13.5C0.5 13.7766 0.723438 14 1 14H11C11.2766 14 11.5 13.7766 11.5 13.5V3.86406C11.5 3.73125 11.4469 3.60313 11.3531 3.50938ZM10.3469 4.09375H7.40625V1.15313L10.3469 4.09375ZM10.375 12.875H1.625V1.125H6.34375V4.5C6.34375 4.67405 6.41289 4.84097 6.53596 4.96404C6.65903 5.08711 6.82595 5.15625 7 5.15625H10.375V12.875ZM6.5 6.375C6.5 6.30625 6.44375 6.25 6.375 6.25H5.625C5.55625 6.25 5.5 6.30625 5.5 6.375V8.0625H3.8125C3.74375 8.0625 3.6875 8.11875 3.6875 8.1875V8.9375C3.6875 9.00625 3.74375 9.0625 3.8125 9.0625H5.5V10.75C5.5 10.8188 5.55625 10.875 5.625 10.875H6.375C6.44375 10.875 6.5 10.8188 6.5 10.75V9.0625H8.1875C8.25625 9.0625 8.3125 9.00625 8.3125 8.9375V8.1875C8.3125 8.11875 8.25625 8.0625 8.1875 8.0625H6.5V6.375Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.ec67748fe806290f1fae697d7d6ff103.svg";
export { ForwardRef as ReactComponent };